/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CustomInputs */

/** @type {(inputs: CustomInputs) => LocalizedString} */
const fr_custom = () => /** @type {LocalizedString} */ ('custom')

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {CustomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const custom = /** @type {((inputs?: CustomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CustomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Custom")
	return fr_custom(inputs)
});